export default {"src":"/_next/static/media/zen-core-icon.149964e2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};